import React from 'react'
import { Typography } from '@mui/material'
// Components
import NotificationModal from '../notification'
// Hooks
import useBranches from '../../../hooks/branch/useBranches';

const getBranchName = (branchCode, branches) => branches[branchCode] || '';

const TerminalQrPvModal = ({ open, billingCode, branchCode, onAccept }) => {
  const { branchesForDisplay } = useBranches();
  return (
    <NotificationModal
      open={open}
      variant='warning'
      onAccept={onAccept}
    >
      <Typography variant="body1" component="p">
        Esta venta contiene pago/s con Terminal QR, la devolución total se debe realizar en el Punto de Venta <strong>{billingCode}</strong> ({getBranchName(branchCode, branchesForDisplay)}).
      </Typography>
      </NotificationModal>
  )
}

export default TerminalQrPvModal